<template>
  <div class="searchBox">
    <el-input
      v-model="keywords"
      :placeholder="placeholder"
      @keyup.enter.native="searchDepartment"
    ></el-input>
    <span class="iconBox" @click="searchDepartment">
      <i class="icon icon-search"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: () => "支持搜索部门",
    },
  },
  data() {
    return {
      keywords: "",
    };
  },
  methods: {
    searchDepartment() {
      this.$emit("handleSearch", this.keywords);
    },
  },
};
</script>

<style lang="scss" scoped>
.searchBox {
  display: inline-flex;
  .iconBox {
    width: 30px;
    background-color: rgba(22, 155, 213, 1);
    flex-shrink: 0;
    text-align: center;
    line-height: 26px;
    cursor: pointer;
  }
}
</style>
